import { NavLink } from "react-router-dom";

import { PRIMARY_NAV_ITEMS, SUPPORT_NAV_ITEMS } from "../routes";
import { Button } from "../components/Button";
import { cx } from "../lib/cx";

interface MobileNavDrawerProps {
  open: boolean;
  onClose: () => void;
}

export function MobileNavDrawer({ open, onClose }: MobileNavDrawerProps) {
  return (
    <div className={cx("mobile-drawer-shell", open && "is-open")} aria-hidden={!open}>
      <button type="button" className="mobile-drawer-backdrop" onClick={onClose} aria-label="Close navigation" />
      <aside className="mobile-drawer" aria-label="Mobile navigation">
        <div className="row-between">
          <div>
            <div className="brand-title">400 Norwood</div>
            <div className="brand-subtitle">Investor Site</div>
          </div>
          <Button variant="ghost" onClick={onClose}>Close</Button>
        </div>
        <div className="stack-sm" style={{ marginTop: "20px" }}>
          <div
            style={{
              fontSize: "0.72rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "rgba(198,211,234,0.62)"
            }}
          >
            Primary investor path
          </div>
          <nav className="mobile-nav-list" aria-label="Primary">
            {PRIMARY_NAV_ITEMS.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end
                className={({ isActive }) => cx("mobile-nav-link", isActive && "is-active")}
                onClick={onClose}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="stack-sm" style={{ marginTop: "24px" }}>
          <div
            style={{
              fontSize: "0.72rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "rgba(198,211,234,0.62)"
            }}
          >
            Appendix / diligence
          </div>
          <nav className="mobile-nav-list" aria-label="Support and appendix">
            {SUPPORT_NAV_ITEMS.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end
                className={({ isActive }) => cx("mobile-nav-link", isActive && "is-active")}
                onClick={onClose}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div
          style={{
            marginTop: "24px",
            padding: "14px 16px",
            borderRadius: "18px",
            border: "1px solid rgba(255,255,255,0.08)",
            background: "rgba(255,255,255,0.03)",
            color: "rgba(221, 231, 247, 0.82)",
            lineHeight: 1.5
          }}
        >
          <div
            style={{
              fontSize: "0.72rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "rgba(198,211,234,0.62)"
            }}
          >
            Investor hierarchy
          </div>
          <div style={{ marginTop: "8px" }}>Primary investor pages lead first. Diligence appendix pages stay available for follow-up review, but they no longer drive the opening path.</div>
        </div>
      </aside>
    </div>
  );
}
